import React, { useState } from 'react';
import '../css/Profile.css';

const Profile = () => {
  // Utiliser un état pour suivre l'élément cliqué
  const [selectedYear, setSelectedYear] = useState(null);

  // Fonction qui se déclenche au clic sur un élément
  const handleClick = (year) => {
    setSelectedYear(year); // Met à jour l'état pour l'année sélectionnée
  };

  return (
    <section id="profile" className="profile-section">
      <div className="vertical-line-profile"></div>

      {/* Timeline */}
      <ol className="timeline">
        <li onClick={() => handleClick(2008)}>2008
          <span>
            Diplôme d'Hôte d'accueil & Guide Touristique.
          </span>
        </li>
        <li onClick={() => handleClick(2011)}>2011
          <span>
            Certificat de Capacité - Spécialiste en Restauration.
          </span>
        </li>
        <li onClick={() => handleClick(2016)}>2016
          <span>
            Diplôme Hôtelier-Restaurateur Diplôme "ES".
          </span>  
        </li>
        <li onClick={() => handleClick('2018-2021')}>2018 - 2021
          <span>
            Certificat de travail chez Dell Technologies.
          </span>
        </li>
        <li onClick={() => handleClick(2022)}>2022
          <span>
            Stage de Support Informatique chez Geneva Business News, Genève.
          </span>
        </li>
        <li onClick={() => handleClick('2022-en-cours')}>2022 - en cours
          <span>
            Diplôme Architecte en Technologie du numérique à l'école 42 Lausanne.
          </span>
        </li>
      </ol>

      {/* Affichage de l'image en fonction de l'année sélectionnée */}
      {selectedYear && (
        <div className="image-container">
          <img
            src={require(`../images/${selectedYear}.png`)} 
            alt={`Year ${selectedYear}`} 
            className="timeline-image"
          />
        </div>
      )}

      {/* Rectangle d'information */}
      <div className="profile-info-rectangle">
          <p>
          <p><strong>
              Découvrez ci-dessous mon parcours unique
          </strong></p>
            J'ai commencé dans l'accueil et le tourisme, avant de me spécialiser en restauration et de travailler plusieurs années dans ce domaine. 
            Mon expérience chez Dell Technologies m'a révélé ma passion pour la technologie, que j'ai ensuite approfondie lors d'un stage en communication. 
            Aujourd'hui, je suis en formation à l'école 42 Lausanne, où je développe mes compétences en programmation et m'épanouis dans cet univers stimulant.
            <p style={{ fontStyle: 'italic', fontSize: '0.8em' }}>
              Vous pouvez cliquer sur les cercles. </p>
        </p>
      </div>
    </section>
  );
};

export default Profile;
